import styled from 'styled-components';
import { viewports } from 'app/shared/styles/_breakpoints';
import { font } from 'app/shared/styles/_fontsize';
import Container from 'app/shared/core/Container';
import type { ComponentType } from 'react';

export const HdpPpcLink: ComponentType<React.ComponentProps<typeof Container>> = styled(Container)`
  ${font.sm};
  @media ${viewports['md-and-up']} {
    ${font.md};
  }
`;
